let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gYFh9")).then(() => parcelRequire('eZwJm'));